import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  // urlPattern = /^(?:(http(s)?)?(sftp)?(ftp)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
  urlPattern = /^https?:\/\/[^\s]+(?:[^\s]* [^\s]*)*$/i;
  emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  urlPatternWithNA = /^(https?:\/\/[^\s]+(?:[^\s]* [^\s]*)*|NA)$/i;

  getStatusValue(item:any) {
    let statusVal:any = {};
    if (item) {
      statusVal = 'Active';
    } else {
      statusVal = 'InActive';
    }
    return statusVal;
  }

  getStatusRetrunValue(item:any) {
    let statusVal:any = {};
    if (item == 'Active') {
      statusVal = true;
    } else {
      statusVal = false;
    }
    return statusVal;
  }
}
